import {afterBrowserRepaintDo, padLeftToLength} from "../../global/globalUtils";
import {StocklogoController, StocklogoEventnames} from "./stocklogoController";
import type {StockLogoCategory, StockLogoPoolEntry} from "./stocklogoController";
import {EventListener, EventVerteiler} from "../../global/eventVerteiler";
import {HTMLPrinter} from "../../global/htmlprinter";
import {StockLogo} from "../selectableObjects";
import {StockLogoSearch} from "./stocklogoSearch";

export class KeyValue {
    public key;
    public value;

    public constructor(key, value) {
        this.key = key;
        this.value = value;
    }
}

export class KeyValueContainer {

    public container: KeyValue[] = [];

    public joinValues(delimiter) {
        return this.container.map(kv => kv.value).join(delimiter);
    }

    public sortbyKey() {
        this.container.sort((kv1, kv2) => kv1.key.localeCompare(kv2.key));
    }

    push(element: any) {
        this.container.push(element);
    }

    concat(kvc: KeyValueContainer) {
        this.container = this.container.concat(kvc.container);
    }
}


export class StocklogoViewController extends EventListener {

    public static getSubDirectoryFromStockLogoID = id => padLeftToLength((id % 100).toString(10), 2, "0");

    public static hideOverlay = (overlay) => $(".overlay-owayo-" + overlay).removeClass("active");
    public static showOverlay = (overlay) => $(".overlay-owayo-" + overlay).addClass("active");

    public static hideAllOverlays() {
        StocklogoViewController.hideOverlay("logopool");
        StocklogoViewController.hideOverlay("logopool_choice");
        StockLogoSearch.hideSearchOverlay();
    }

    private search: StockLogoSearch;

    public constructor() {
        super();
        this.search = new StockLogoSearch();

        this.addEventListener(StocklogoEventnames.LOGOSLOADED, () => {
            StocklogoViewController.printCategorySelectWindow();
        });
        StocklogoViewController.initBackAndCloseButtons();
    }

    private static initBackAndCloseButtons() {
        const _self = StocklogoViewController;
        $(".overlay-owayo-logopool").find(".btn-close, .btn-back").off().click(() => _self.hideOverlay("logopool"));
        $(".overlay-owayo-logopool_choice .btn-back").off().click(() => {
            _self.LogoPoolChoiceBackButtonClicked();
        });
        $(".overlay-owayo-logopool_choice .btn-close").off().click(() => StocklogoViewController.hideOverlays());
    }

    public static hideOverlays() {
        $(".overlay-logo_edit, .overlay-logo-upload, .overlay-owayo-logopool, .overlay-owayo-logopool_choice, .overlay-owayo-logopool_searchresults").removeClass("active");
        $(".logo-new").addClass("active");
    }


    private static getSubcategoryEntries(subcategories: StockLogoCategory[]): KeyValueContainer {
        return subcategories.reduce(
            function (carry, c) {
                carry.push(
                    new KeyValue(
                        c.nameLocalized, StocklogoViewController.getCategoryOverviewEntry(c, true)
                    )
                );
                return carry;
            },
            new KeyValueContainer()
        )
    }

    private static displayCategory(cat: StockLogoCategory, subcategories: StockLogoCategory[]) {

        StockLogoSearch.hideSearchbar();
        const logosAndSubCategories = new KeyValueContainer();
        if (cat === null) {
            return;
        }
        $(".overlay-owayo-logopool_choice").data("masterkategorie", cat.masterkategorie).data("currentcategory", cat.name);
        $(".overlay-owayo-logopool_choice .logopool-cat-title").text(cat.nameLocalized);
        const DOMElement = $(".overlay-owayo-logopool_choice .logo-pool");
        logosAndSubCategories.concat(StocklogoViewController.getSubcategoryEntries(subcategories));
        logosAndSubCategories.concat(StocklogoViewController.getCategoryLogosHTML(cat.logos, cat.logonamenAnzeigen));

        if (cat.name === "Flaggen") {
            logosAndSubCategories.sortbyKey();
        }
        DOMElement.html(logosAndSubCategories.joinValues("\n"));

        StocklogoViewController.setOrRemoveGreyLogoBackgroundForCategoriesWithWhiteEdgeLogos(cat, DOMElement);
        StocklogoViewController.initClickHandlers();

        StocklogoViewController.showOverlay("logopool_choice");
    }


    private static setOrRemoveGreyLogoBackgroundForCategoriesWithWhiteEdgeLogos(category: StockLogoCategory, domelement: JQuery) {
        if (category.enthaeltLogosMitWeisserRandflaeche) {
            domelement.addClass("bg-grey-logo");
        } else {
            domelement.removeClass("bg-grey-logo");
        }
    }

    private static initClickHandlers() {
        $(".overlay-owayo-logopool_choice .logo-box[data-id]").click(function (event) {
            const id = $(event.currentTarget).data("id");
            EventVerteiler.broadcast(StocklogoEventnames.LOGOCLICKED, id);
        })
        $(".overlay-owayo-logopool_choice .logo-box[data-category]").click(function (event) {
            const categoryName = $(event.currentTarget).data("category");
            StocklogoViewController.displayCategory((StocklogoController.getCategory(categoryName) as StockLogoCategory), []);
        })
    }

    private static getLogoContainer(logo: StockLogoPoolEntry, showName) {
        const p = HTMLPrinter;

        return p.liWithProps(
            p.cssClass("logo-box"),
            p.dataProp("id")(logo.stockLogoID),
            p.dataProp("keywords")(logo.keywords.join(","))
        )(
            p.divWitHProps(p.cssClass("box-wrapper"))(
                p.divWitHProps(p.cssClass('logo-img-wrapper'))(
                    p.img(
                        p.cssClass("logo-box-image-owayo"),
                        p.alt(logo.Name),
                        p.src("https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=80/" + logo.previewPicture),
                        p.srcset(
                            "https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=80/" + logo.previewPicture,
                            "https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=120/" + logo.previewPicture,
                            "https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=160/" + logo.previewPicture
                        )
                    ),
                    //p.spanWithProps(p.cssClass(showName ? "filled-logoname" : ""))(showName ? logo.nameLocalized : "")
                ),
                p.spanWithProps(p.cssClass(showName ? "filled-logoname" : ""))(showName ? logo.nameLocalized : "")
            )
        );
    }

    private static getCategoryLogosHTML(categoryLogos: StockLogoPoolEntry[], showLogoNames = false): KeyValueContainer {
        const container = new KeyValueContainer;
        const withoutDiscarded = categoryLogos.filter(l=>!l.discarded);
        for(const l in withoutDiscarded) {
            container.push(
                new KeyValue(
                    categoryLogos[l].nameLocalized,
                        StocklogoViewController.getLogoContainer(withoutDiscarded[l], showLogoNames)
                )
            );
        }
        return container;
    }

    public static printCategorySelectWindow() {
        const container = $(".overlay-owayo-logopool .logo-pool");
        container.empty();
        StocklogoController.getLogos().filter(c => c.masterkategorie === null).forEach(c => container.append(StocklogoViewController.getCategoryOverviewEntry(c)));
        $(".overlay-owayo-logopool .logo-box").off().click(function (event) {
            const categoryName = $(event.currentTarget).data("category");
            StocklogoViewController.displayCategory(
                (StocklogoController.getCategory(categoryName) as StockLogoCategory), StocklogoController.getSubCategories(categoryName))
        });
    }

    private static getCategoryOverviewEntry(category: StockLogoCategory, writeNumberOfLogos = false) {
        const p = HTMLPrinter;
        const label = category.nameLocalized + (writeNumberOfLogos ? " " + p.roundbracket(category.logos.length) : "");

        return p.liWithProps(
            p.cssClass("logo-box"),
            p.dataProp("category")(category.name),
            (category.masterkategorie !== null ? p.dataProp("masterkategorie")(category.masterkategorie) : "")
        )(
            p.divWitHProps(p.cssClass("logo-img-wrapper"))(
                p.img(
                    p.cssClass("logo-box-image-owayo"),
                    p.alt(category.name),
                    p.src("https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=80" + StockLogo.getPreviewPictureURL(category.previewStockLogoID)),
                    p.srcset(
                        "https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=80" + StockLogo.getPreviewPictureURL(category.previewStockLogoID),
                        "https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=120" + StockLogo.getPreviewPictureURL(category.previewStockLogoID),
                        "https://owayo-cdn.com/cdn-cgi/image/format=auto,fit=contain,width=160" + StockLogo.getPreviewPictureURL(category.previewStockLogoID)
                    )
                )
            ),
            p.span(label)
        );
    }


    public static scrollToElement(scrollContainer, target) {
        const top = ($(target).offset() as { top }).top;
        if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
            window.scrollTo(200, top)
        } else {
            $(scrollContainer).animate({scrollTop: top}, 500);
        }

    }

    private static returnToMasterCategory(masterkategorie, currentCategory) {
        StocklogoViewController.displayCategory(
            (StocklogoController.getCategory(masterkategorie) as StockLogoCategory),
            StocklogoController.getSubCategories(masterkategorie)
        );
        afterBrowserRepaintDo(
            () => StocklogoViewController.scrollToElement($('.logo-upload-content'), $(".overlay-owayo-logopool_choice [data-category='" + currentCategory + "']"))
        );
    }

    private static LogoPoolChoiceBackButtonClicked() {
        const $overlay = $(".overlay-owayo-logopool_choice");
        const masterkategorie = $overlay.data("masterkategorie");
        if (typeof (masterkategorie) !== "undefined" && masterkategorie !== null && masterkategorie !== "") {
            StocklogoViewController.returnToMasterCategory(masterkategorie, $overlay.data("currentcategory"))

        } else {
            StocklogoViewController.hideOverlay("logopool_choice");
            StockLogoSearch.showSearchbar();

        }
    }
}
